import SmsOutlinedIcon from '@mui/icons-material/SmsOutlined';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import { ReactNode } from 'react';

import { AuthDeliveryChannel } from '@shared/enums/auth-delivery-channel.enum';

/** i18n key for the "Code sent via X" status line, per channel. */
export const sentViaKey: Record<AuthDeliveryChannel, string> = {
  [AuthDeliveryChannel.TELEGRAM]: 'userAuth.phoneConfirmation.sentViaTelegram',
  [AuthDeliveryChannel.SMS]: 'userAuth.phoneConfirmation.sentViaSms',
  [AuthDeliveryChannel.EMAIL]: 'userAuth.phoneConfirmation.sentViaEmail',
};

/** i18n key for the short channel label used on "send another way" chips. */
export const viaLabelKey: Record<AuthDeliveryChannel, string> = {
  [AuthDeliveryChannel.TELEGRAM]: 'userAuth.phoneConfirmation.viaTelegram',
  [AuthDeliveryChannel.SMS]: 'userAuth.phoneConfirmation.viaSms',
  [AuthDeliveryChannel.EMAIL]: 'userAuth.phoneConfirmation.viaEmail',
};

/** Icon for a delivery channel. Telegram uses the brand logo asset; SMS/email
 * use MUI glyphs that inherit the surrounding text color. */
export const getChannelIcon = (
  channel: AuthDeliveryChannel,
  size = 18,
): ReactNode => {
  if (channel === AuthDeliveryChannel.TELEGRAM) {
    return (
      <img
        src="/telegram-logo.png"
        alt=""
        width={size}
        height={size}
        style={{ display: 'block' }}
      />
    );
  }
  const sx = { fontSize: size, color: 'inherit' };
  return channel === AuthDeliveryChannel.SMS ? (
    <SmsOutlinedIcon sx={sx} />
  ) : (
    <MailOutlineIcon sx={sx} />
  );
};
